var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOpenLarge = function SvgOpenLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1110.000000, -66.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1110.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.59872116e-15 0 6 1.19904087e-15 6 1.8 1.8 1.8 1.8 6 0 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 16 10 16 10 14.2 14.2 14.2 14.2 10 16 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 2.70090327e-15 16 6 14.2 6 14.2 1.8 10 1.8 10 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 16 3.19744231e-15 10 1.8 10 1.8 14.2 6 14.2 6 16"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open_large.4b9e4586.svg";
export { ForwardRef as ReactComponent };